export default "__VITE_ASSET__Bxsdlfsy__"